export interface ListParam {
    curPage?: number;
    rowPerPage?: number;
    category_id?: number;
    corp_id?: number;
    sector_id?: number;
    yyyymmdd?: string;
    hour?: string;
    isu_srt_cd?: string;
    service_type?: string;
}


export const defaultListParam = (): ListParam => ({
    curPage: 1,
    rowPerPage: 10,
    service_type: 'ST',
});